import { ExemptVehicleType } from '@EcamModel/model/CameraNotes';

export const exemptVehicleTypeReadableMapping: Record<ExemptVehicleType, string> = {
    [ExemptVehicleType.Bus]: 'Bus',
    [ExemptVehicleType.Hgv]: 'HGV',
    [ExemptVehicleType.Truck]: 'Truck',
    [ExemptVehicleType.Van]: 'Van',
};

export const exemptVehicleTypeOptions: { label: string; value: ExemptVehicleType }[] = [
    { label: exemptVehicleTypeReadableMapping[ExemptVehicleType.Bus], value: ExemptVehicleType.Bus },
    { label: exemptVehicleTypeReadableMapping[ExemptVehicleType.Hgv], value: ExemptVehicleType.Hgv },
    { label: exemptVehicleTypeReadableMapping[ExemptVehicleType.Truck], value: ExemptVehicleType.Truck },
    { label: exemptVehicleTypeReadableMapping[ExemptVehicleType.Van], value: ExemptVehicleType.Van },
];
